(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/models/payout-table.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/models/payout-table.js');

'use strict';

svs.numbergames.results.models.PayoutTable = svs.numbergames.core.NumbergamesModel.extend({
  defaults: {
    productId: undefined,
    type: undefined,
    payoutType: undefined,
    distribution: undefined,
    dromvinstPayout: undefined,
    millionRain: undefined
  }
});

 })(window);